import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="discount"
export default class extends Controller {
  static targets = ["dateStart", "dateEnd", "operator", "result", "rs", "button"];

  getSelectedRadioButton() {
    const selectedButton = this.buttonTargets.find(button => button.checked);
    return selectedButton ? selectedButton.value : undefined;
  }

  getSelectedCheckboxes() {
    const selectedButtons = this.buttonTargets.filter(button => button.checked);
    return selectedButtons.map(button => button.value);
  }

  calculate(event) {
    event.preventDefault();

    const operatorId = this.operatorTarget.value;
    const startDate = this.dateStartTarget.value;
    const endDate = this.dateEndTarget.value;
    const games = this.getSelectedCheckboxes();
    const rsExclusive = this.rsTarget.value;

    const isVerificationSuccessful = this.verifications(operatorId, startDate, endDate, games, rsExclusive);
    if (!isVerificationSuccessful) {
      return;
    }

    fetch(`/bo/admin/rate_discounts/calculate_discount?operator=${operatorId}&start_date=${startDate}&end_date=${endDate}&game_ids=${games}&rs_exclusive=${rsExclusive}`)
      .then(response => response.json())
      .then(data => {
        const formatter = new Intl.NumberFormat('es-ES', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        this.resultTarget.value = formatter.format(data.result_total);
      })
      .catch(error => {
        console.error(error);
      });
  }

  calculate_account_manager(event) {
    event.preventDefault();

    const operatorId = this.operatorTarget.value;
    const startDate = this.dateStartTarget.value;
    const endDate = this.dateEndTarget.value;
    const games = this.getSelectedCheckboxes();
    const rsExclusive = this.rsTarget.value;

    const isVerificationSuccessful = this.verifications(operatorId, startDate, endDate, games, rsExclusive);
    if (!isVerificationSuccessful) {
      return;
    }

    fetch(`/bo/account_manager/rate_discounts/calculate_discount?operator=${operatorId}&start_date=${startDate}&end_date=${endDate}&game_ids=${games}&rs_exclusive=${rsExclusive}`)
      .then(response => response.json())
      .then(data => {
        const formatter = new Intl.NumberFormat('es-ES', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        this.resultTarget.value = formatter.format(data.result_total);
      })
      .catch(error => {
        console.error(error);
      });
  }

  calculate_explorer(event) {
    event.preventDefault();

    const operatorId = this.operatorTarget.value;
    const startDate = this.dateStartTarget.value;
    const endDate = this.dateEndTarget.value;
    const games = this.getSelectedCheckboxes();
    const rsExclusive = this.rsTarget.value;

    const isVerificationSuccessful = this.verifications(operatorId, startDate, endDate, games, rsExclusive);
    if (!isVerificationSuccessful) {
      return;
    }

    fetch(`/bo/explorer/rate_discounts/calculate_discount?operator=${operatorId}&start_date=${startDate}&end_date=${endDate}&game_ids=${games}&rs_exclusive=${rsExclusive}`)
      .then(response => response.json())
      .then(data => {
        const formatter = new Intl.NumberFormat('es-ES', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        this.resultTarget.value = formatter.format(data.result_total);
      })
      .catch(error => {
        console.error(error);
      });
  }

  verifications(operatorId, startDate, endDate, games, rsExclusive) {
    if (!operatorId) {
      alert("Por favor, completa el campo Operador.");
      return false;
    }
    if (!startDate) {
      alert("Por favor, selecciona la Fecha de inicio.");
      return false;
    }
    if (!endDate) {
      alert("Por favor, selecciona la Fecha de finalización.");
      return false;
    }
    if (!games) {
      alert("Por favor, selecciona un Juego.");
      return false;
    }
    if (!rsExclusive || rsExclusive > 100) {
      alert("Por favor, completa el campo RS y debe ser menor a 100 %");
      return false;
    }

    return true;
  }
}
